import { Radio, Tooltip } from 'antd';
import { observer } from 'mobx-react-lite';
import * as React from 'react';
import { useTranslation } from 'react-i18next';

import { DictionarySettingsValueModel } from 'stores/models/fieldsSettings';

import { useDictionaryTableContext } from '../../context';

type Props = {
  entity: DictionarySettingsValueModel;
};

const ByDefaultRadioButton: React.FC<Props> = ({ entity }) => {
  const { t } = useTranslation();
  const { store } = useDictionaryTableContext();

  const handleOnClick = React.useCallback(() => {
    store.dictionarySettingsDefaultValue.setDefaultValue(entity.value);
  }, [entity.value, store.dictionarySettingsDefaultValue]);

  const checked = React.useMemo(() => {
    return store.isValueChecked(entity);
    // eslint-disable-next-line
  }, [entity, store.dictionarySettingsDefaultValue.defaultValue, store.allValuesUnique]);

  const disabled = entity.value === '' || !store.allValuesUnique;

  if (!store.allValuesUnique) {
    return (
      <Tooltip title={t('common.allValuesMustBeUnique')}>
        <Radio checked={checked} disabled={disabled} onClick={handleOnClick} />
      </Tooltip>
    );
  }

  return (
    <Radio checked={checked} disabled={disabled} onClick={handleOnClick} />
  );
};

export default observer(ByDefaultRadioButton);
